/** Совпадает с CHECK в миграции project_files и whitelist на сервере. */
export const PROJECT_FILE_TYPE_VALUES = ['Текст', 'Правки', 'Сэмпл', 'Глоссарий'] as const;

export type ProjectFileTypeValue = (typeof PROJECT_FILE_TYPE_VALUES)[number];

/** Первый элемент `PROJECT_FILE_TYPE_VALUES` — вынесено для сравнений без магических строк. */
export const PROJECT_FILE_TYPE_TEXT: ProjectFileTypeValue = PROJECT_FILE_TYPE_VALUES[0];
